/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { createSelector } from '@reduxjs/toolkit';
import { initialState } from './slice';
/**
 * Getting entire user invites state into the component
 */
const selectDomain = (state) => state['feature/audit-logs'] || initialState;
/**
 * Getting the loader state into the component
 */
export const selectLoader = createSelector(
  [selectDomain],
  (auditLogsState) => auditLogsState?.loading
);

/**
 * Getting the audit logs state into the component
 */
export const selectAuditLogs = createSelector(
  [selectDomain],
  (auditLogsState) => auditLogsState?.auditLogs
);

/**
 * Getting the users list state into the component
 */
export const selectUsernameList = createSelector([selectDomain], (auditLogsState) =>
  auditLogsState.usersList?.map((data) => ({
    id: data?.username,
    value: data?.username,
  }))
);
